export enum DatetimeFormatLanguageEnum {
    datetime = 0,
    datetimeFormatted = 1,
    datetimeShortFormatted = 2,
    datetimeUtc = 3,
    datetimeUtcFormatted = 4,
    datetimeUtcShortDescription = 5,
    datetimeUtcShortFormatted = 6
}